import React from 'react';
import PropTypes from 'prop-types';

import AmbBaseLink from '@amblique/base/app/components/link';
import {Link as ChakraLink} from '@salesforce/retail-react-app/app/components/shared/ui/Link';

import {resolveNativeAnchorHref} from '@amblique/king-living/app/contentful/helpers/resolve-contentful-link-url';

const Link = React.forwardRef(({href, to, useNavLink, parse, isExternal, ...rest}, ref) => {
  const nativeHref = resolveNativeAnchorHref(to, href, isExternal);

  if (nativeHref === false) {
    return <ChakraLink ref={ref} as="span" {...rest} />;
  }

  if (nativeHref) {
    return <ChakraLink ref={ref} {...rest} href={nativeHref} isExternal={isExternal} />;
  }

  return (
    <AmbBaseLink
      ref={ref}
      href={href}
      isExternal={isExternal}
      parse={parse}
      to={to}
      useNavLink={useNavLink}
      {...rest}
    />
  );
});

Link.displayName = 'Link';
Link.propTypes = {
  href: PropTypes.string,
  isExternal: PropTypes.bool,
  parse: PropTypes.bool,
  to: PropTypes.string,
  useNavLink: PropTypes.bool,
};

export default React.memo(Link);
